<script>
import Spinner from '@/components/atoms/Spinner'
export default {
    name: 'ButtonLoader',
    components: { Spinner },
    props: {
        loading: Boolean,
        inline: Boolean,
        disabled: Boolean,
        stop: Boolean,
    },
    methods: {
        onClick(e) {
            if (this.stop) e.stopPropagation()
            this.$emit('click')
        },
    },
}
</script>

<template lang="pug">
button(@click="onClick" :disabled="disabled")
    span.btn-loader(:class="{'loading': loading, 'inline': inline}")
        spinner.btn-loader-spinner
        slot
</template>
